import React from 'react';
import { FaFacebookOfficial, FaInstagram, FaTwitter } from 'react-icons/lib/fa';

const SocialIcons = () => {
    return (
        <div>
            <a
                target="_blank"
                className="socialLink"
                href="https://www.facebook.com/youthcampsforchrist">
                <FaFacebookOfficial />
            </a>
            <a
                target="_blank"
                className="socialLink"
                href="https://www.instagram.com/youthcampsforchrist/">
                <FaInstagram />
            </a>
            <a
                target="_blank"
                className="socialLink"
                href="https://twitter.com/YCFC1968">
                <FaTwitter />
            </a>
        </div>
    );
};

export default SocialIcons;



// WEBPACK FOOTER //
// ./src/components/Footer/SocialIcons.js